/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2023
 * @flow
 */

import React from 'react';
import classes from "./StepInput.module.css";

const StepInput = ({ placeholder, type, value, onChange, inputStyle, disabled }) => {
  return (
    <div className={classes.container}>
      <label className={classes.stepLabel}>{placeholder}</label>
      <input
        type={type}
        value={value}
        onChange={event => onChange(event.target.value)}
        className={inputStyle}
        disabled={disabled}
        step={"1"}
        min={"1"}
      />
    </div>
  );
};

export default StepInput;
